module.exports = "mutation UpdateLineShippingFees($lineId:ID!,$priceExVat:Float!){updateLineShippingFees(lineId:$lineId,priceExVat:$priceExVat){success}}"